module.exports = __webpack_public_path__ + "static/media/InvestvertexWhite.9f80a14d.png";